import React from 'react';
import moment from 'moment';

export const LastShippedReplenishments = (props) => {

    if (!props.replenishments || !props.replenishments.length) {
        return '';
    }

    let recentlyShippedReplClone = [...props.replenishments];

    recentlyShippedReplClone.sort((a, b) => {
        const shippedA = moment.utc(a);
        const shippedB = moment.utc(b);

        return shippedA > shippedB ? -1 : 1;
    });

    recentlyShippedReplClone = recentlyShippedReplClone.slice(0, 3);

    return recentlyShippedReplClone.map(shippedRepl => {
        const shipped = shippedRepl.shippedAt ? moment.utc(shippedRepl.shippedAt).local().format('DD.MM.YYYY HH:mm:ss') : '';

        return (
            <div key={shippedRepl.id} style={{display: 'grid', gridTemplateColumns: '30px 10px 90px ', gridGap: '2px'}}>
                <div>{shippedRepl.id}</div>
                <div>{shippedRepl.quantity}</div>
                <div>{shipped}</div>
            </div>
        )
    });


};

export default LastShippedReplenishments;


// WEBPACK FOOTER //
// ./src/admin/scheduledreplenishment/LastShippedReplenishments.js